import { render } from "./GraduationCap.vue?vue&type=template&id=151da166"
import script from "./GraduationCap.vue?vue&type=script&setup=true&lang=js"
export * from "./GraduationCap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/GraduationCap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "151da166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('151da166', __exports__)) {
    api.reload('151da166', __exports__)
  }
  
  module.hot.accept("./GraduationCap.vue?vue&type=template&id=151da166", () => {
    api.rerender('151da166', render)
  })

}


export default __exports__